<template>
  <div class="promotion-records">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- 使用现有的 GetUser 组件 -->
        <el-form-item label="选择用户">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-input
                v-model="selectedUserName"
                placeholder="请选择用户"
                readonly
                style="width: 300px"
              >
                <template slot="append">
                  <el-button @click="openUserDialog" icon="el-icon-search">选择用户</el-button>
                </template>
              </el-input>
            </el-col>
            <el-col :span="6" v-if="selectedUser">
              <el-button @click="clearUserSelection" type="text" icon="el-icon-close" style="margin-left: 19px;">清除</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        
        <el-form-item label="推广状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未开始" value="0"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已结束" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="角色">
          <el-select v-model="searchForm.role" placeholder="请选择状态">
            <el-option label="全部" value="0"></el-option>
            <el-option label="商会" value="shanghui"></el-option>
            <el-option label="企业" value="company"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="推广时间">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 用户信息卡片 -->
    <el-card v-if="selectedUser" class="user-info-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>用户信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="clearUserSelection">
          清除选择
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="user-info-item">
            <img :src="selectedUser.avatarUrl" class="user-avatar" width="40" height="40" />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>用户ID：</label>
            <span>{{ selectedUser.user_id }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>昵称：</label>
            <span>{{ selectedUser.nickName }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>手机号：</label>
            <span>{{ selectedUser.mobile || '未填写' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 数据统计 -->
    <el-card v-if="selectedUser" class="stats-card" shadow="never">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.total || 0 }}</div>
            <div class="stat-label">总推广</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.transformationNum || 0 }}</div>
            <div class="stat-label">总成功数</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.viewCount || 0 }}</div>
            <div class="stat-label">总浏览</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.successRate || 0 }}%</div>
            <div class="stat-label">转化率</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table 
          size="small" 
          :data="tableData" 
          border 
          style="width: 100%" 
          v-loading="loading"
          @sort-change="handleSortChange"
        >
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="title" label="推广标题" min-width="200">
            <template slot-scope="scope">
              <div class="promotion-title">{{ scope.row.title || '无标题' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="推广次数" width="100" align="center"></el-table-column>
          <el-table-column prop="success_num" label="成功次数" width="100" align="center"></el-table-column>
          <el-table-column prop="view_num" label="浏览次数" width="100" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getStatusTagType(scope.row.status)" 
                size="small"
              >
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="推广时间" width="180" sortable="custom"></el-table-column>
          
          <!-- 新增：查看推广给了谁 -->
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button 
                @click="viewPromotionTargets(scope.row)" 
                type="primary" 
                size="small"
                icon="el-icon-user"
              >
                查看推广对象
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background 
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 图表容器 -->
    <div class="echarts-container">
      <el-card shadow="never" class="chart-card">
        <div slot="header" class="clearfix">
          <span>推广数据趋势图(默认查询最近7天的数据)</span>
        </div>
        <div ref="barChart" id="barChart" style="width: 100%; height: 500px;"></div>
      </el-card>
    </div>

    <!-- 使用现有的 GetUser 组件 -->
    <GetUser 
      :is_open="userDialogVisible" 
      @close="closeUserDialog"
      :multi="false"
    ></GetUser>

    <!-- 推广对象对话框 -->
    <el-dialog
      title="推广对象详情"
      :visible.sync="targetsDialogVisible"
      width="60%"
      :before-close="handleTargetsClose"
    >
      <div v-if="currentPromotionData">
        <!-- 推广基本信息 -->
        <el-card class="promotion-info-card" shadow="never">
          <div slot="header">
            <span>推广信息</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="info-item">
                <label>推广标题：</label>
                <span>{{ currentPromotionData.title || '无标题' }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">
                <label>推广时间：</label>
                <span>{{ currentPromotionData.time }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">
                <label>推广次数：</label>
                <span>{{ currentPromotionData.num }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 推广对象列表 -->
        <el-card class="targets-list-card" shadow="never">
          <div slot="header">
            <span>推广对象列表 ({{ promotionTargets.length }} 个)</span>
          </div>
          
          <div v-if="promotionTargetsLoading" class="loading-container">
            <el-skeleton :rows="5" animated />
          </div>
          
          <div v-else-if="promotionTargets.length === 0" class="empty-container">
            <el-empty description="暂无推广对象数据"></el-empty>
          </div>
          
          <div v-else class="targets-list">
            <div class="targets-stats">
              <el-tag type="info">共 {{ promotionTargets.length }} 个手机号</el-tag>
            </div>
            
            <div class="phone-list">
              <div 
                v-for="(phone, index) in promotionTargets" 
                :key="index" 
                class="phone-item"
              >
                <div class="phone-info">
                  <i class="el-icon-phone" style="color: #409EFF; margin-right: 8px;"></i>
                  <span class="phone-number">{{ phone }}</span>
                </div>
                <div class="company"> {{ company_name }} </div>
                <div class="phone-actions">
                  <el-button 
                    type="text" 
                    size="small" 
                    icon="el-icon-phone"
                    @click="makePhoneCall(phone)"
                  >
                    拨打
                  </el-button>
                  <el-button 
                    type="text" 
                    size="small" 
                    icon="el-icon-copy-document"
                    @click="copyPhoneNumber(phone)"
                  >
                    复制
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PromotionApi from '@/api/promotion.js';
import GetUser from '@/components/user/GetUser.vue';
import { divide } from 'lodash';
import echarts from 'echarts';

export default {
  name: 'PromotionRecords',
  components: {
    GetUser
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      searchForm: {
        user_id: '',
        status: '-1',
        role: '0',
        dateRange: []
      },
      selectedUser: null,
      selectedUserName: '',
      userDialogVisible: false,
      stats: {},
      targetsDialogVisible: false,
      currentPromotionData: null,
      promotionTargets: [],
      company_name:'',
      promotionTargetsLoading: false,
      chartInstance: null,
      chartData: []
    };
  },
  created() {
    this.loadUserStats();
    this.getTableList();
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart);
    this.$nextTick(() => {
        this.loadChartData();
    });
  },
  destroyed() {
    this.disposeChart();
    window.removeEventListener('resize', this.resizeChart);
  },
  methods: {
    /*初始化图表*/
    initChart() {      
      this.disposeChart();
      
      const chartDom = this.$refs.barChart || document.getElementById('barChart');
      if (!chartDom) {
        console.warn('图表 DOM 元素不存在，跳过初始化');
        return;
      }
      
      try {
        this.chartInstance = echarts.init(chartDom);
        this.renderChart();
      } catch (error) {
        console.error('初始化图表失败:', error);
        this.chartInstance = null;
      }
    },

    /*渲染图表*/
    renderChart() {
      if (!this.chartInstance || !this.chartData || this.chartData.length === 0) {
        if (this.chartInstance) {
          this.chartInstance.clear();
        }
        return;
      }

      try {
        const xAxisData = this.chartData.map(item => item.time || '未知日期');
        const totalPromotionData = this.chartData.map(item => item.total || 0);
        const viewCountData = this.chartData.map(item => item.viewCount || 0);
        const successCountData = this.chartData.map(item => item.transformationNum || 0);
        const conversionRateData = this.chartData.map(item => {
          const rate = Number(item.successRate) || 0;
          return Math.max(0, Math.min(100, rate));
        });

        const chartOption = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: { color: '#999' }
            },
            formatter: function(params) {
              let result = params[0].name + '<br/>';
              params.forEach(param => {
                let value = param.value;
                if (param.seriesName === '转化率') {
                  value = `${value.toFixed(2)}%`;
                }
                result += `<span style="display:inline-block;margin-right:5px;width:10px;height:10px;background:${param.color};"></span>`;
                result += `${param.seriesName}: ${value}<br/>`;
              });
              return result;
            }
          },
          legend: {
            data: ['总推广数', '浏览数', '总成功数', '转化率'],
            top: 10,
            right: 10,
            textStyle: { fontSize: 12 }
          },
          grid: {
            left: '5%',
            right: '8%',
            bottom: '15%',
            top: '15%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xAxisData,
              axisLabel: {
                rotate: 45,
                interval: 0,
                fontSize: 11
              },
              axisLine: { lineStyle: { color: '#e6e6e6' } },
              splitLine: { show: false }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '数量',
              min: 0,
              nameTextStyle: { color: '#666', fontSize: 12 },
              axisLine: { lineStyle: { color: '#e6e6e6' } },
              splitLine: { lineStyle: { color: '#f5f5f5' } },
              axisLabel: {
                fontSize: 11,
                formatter: '{value}'
              }
            },
            {
              type: 'value',
              name: '转化率(%)',
              min: 0,
              max: 100,
              position: 'right',
              nameTextStyle: { color: '#ee6666', fontSize: 12 },
              axisLine: { lineStyle: { color: '#ee6666' } },
              splitLine: { show: false },
              axisLabel: {
                fontSize: 11,
                formatter: '{value}%'
              }
            }
          ],
          series: [
            {
              name: '总推广数',
              type: 'bar',
              yAxisIndex: 0,
              data: totalPromotionData,
              itemStyle: { color: '#5470c6' },
              barWidth: 15,
              barGap: '30%'
            },
            {
              name: '浏览数',
              type: 'bar',
              yAxisIndex: 0,
              data: viewCountData,
              itemStyle: { color: '#fac858' },
              barWidth: 15
            },
            {
              name: '总成功数',
              type: 'bar',
              yAxisIndex: 0,
              data: successCountData,
              itemStyle: { color: '#91cc75' },
              barWidth: 15
            },
            {
              name: '转化率',
              type: 'line',
              yAxisIndex: 1,
              data: conversionRateData,
              itemStyle: { color: '#ee6666' },
              lineStyle: { width: 3 },
              symbol: 'circle',
              symbolSize: 6,
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(238, 102, 102, 0.3)' },
                  { offset: 1, color: 'rgba(238, 102, 102, 0.05)' }
                ])
              }
            }
          ],
          dataZoom: [
            {
              type: 'inside',
              xAxisIndex: [0],
              start: 0,
              end: 100
            }
          ]
        };

        this.chartInstance.clear();
        this.chartInstance.setOption(chartOption, true);
      } catch (error) {
        console.error('渲染图表失败:', error);
        this.disposeChart();
      }
    },

    /*调整图表大小*/
    resizeChart() {
      if (this.chartInstance && this.selectedUser) {
        try {
          this.chartInstance.resize();
        } catch (error) {
          console.warn('调整图表大小失败:', error);
        }
      }
    },

    /*销毁图表*/
    disposeChart() {
      if (this.chartInstance) {
        try {
          this.chartInstance.dispose();
        } catch (error) {
          console.error('销毁图表失败:', error);
        } finally {
          this.chartInstance = null;
        }
      }
    },

    /*加载图表数据*/
    loadChartData() {
      const user_id = this.selectedUser ? this.selectedUser.user_id : 0;

      PromotionApi.getPromotionChartData({
        user_id: user_id,
        status: this.searchForm.status,
        role: this.searchForm.role,
        start_date: this.searchForm.dateRange ? this.searchForm.dateRange[0] : '', 
        end_date: this.searchForm.dateRange ? this.searchForm.dateRange[1] : ''
      }).then(res => {
        if (res.code === 1 && res.data && res.data.length > 0) {
          this.chartData = res.data;
          this.$nextTick(() => {
            setTimeout(() => {
              this.initChart();
            }, 100);
          });
        } else {
          this.chartData = [];
          this.disposeChart();
          this.$message.info('暂无图表数据');
        }
      }).catch((err) => {
        console.error('加载图表数据失败:', err);
        this.chartData = [];
        this.disposeChart();
        this.$message.error('加载图表数据失败');
      });
    },

    /*打开用户选择对话框*/
    openUserDialog() {
      this.userDialogVisible = true;
    },

    /*关闭用户选择对话框*/
    closeUserDialog(e) {
      this.userDialogVisible = false;
      if (e.type === 'success') {
        const user = e.params;
        this.selectedUser = user;
        this.selectedUserName = `${user.nickName} (ID:${user.user_id})`;
        this.searchForm.user_id = user.user_id;
        
        this.$nextTick(() => {
          this.loadUserStats();
          this.getTableList();
          this.loadChartData();
        });
      }
    },

    /*清除用户选择*/
    clearUserSelection() {
      this.selectedUser = null;
      this.selectedUserName = '';
      this.searchForm.user_id = '';
      this.tableData = [];
      this.totalDataNumber = 0;
      this.stats = {};
      this.chartData = [];
      this.disposeChart();
    },

    /*加载用户统计*/
    loadUserStats() {
      const user_id = this.selectedUser ? this.selectedUser.user_id : 0;
      
      PromotionApi.getPromotionStats({
        user_id: user_id,
        status: this.searchForm.status,
        role: this.searchForm.role
      }).then(res => {
        this.stats = res.data || {};
      }).catch(err => {
        console.error('加载统计数据失败:', err);
        this.stats = {};
      });
    },

    /*获取列表*/
    getTableList() {
      const user_id = this.selectedUser ? this.selectedUser.user_id : 0;

      this.loading = true;
      let params = {
        ...this.searchForm,
        page: this.curPage,
        list_rows: this.pageSize,
        user_id: user_id
      };

      if (params.dateRange && params.dateRange.length === 2) {
        params.start_date = params.dateRange[0];
        params.end_date = params.dateRange[1];
        delete params.dateRange;
      }
      PromotionApi.getPromotionList(params).then(res => {
        this.loading = false;
        this.tableData = res.data.list.data || [];
        this.totalDataNumber = res.data.list.total || 0;
      }).catch(() => {
        this.loading = false;
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*排序变化*/
    handleSortChange({ column, prop, order }) {
      console.log('排序:', prop, order);
      this.getTableList();
    },

    /*搜索查询*/
    onSubmit() {      
      this.curPage = 1;
      this.loadUserStats();
      this.getTableList();
      this.$nextTick(() => {
        this.loadChartData();
      });
    },

    /*重置搜索*/
    resetSearch() {
      this.searchForm = {
        user_id: this.searchForm.user_id,
        status: '-1',
        role: '0',
        dateRange: []
      };
      
      if (this.selectedUser) {
        this.loadUserStats();
        this.getTableList();
        this.$nextTick(() => {
          this.loadChartData();
        });
      }
    },

    /*查看推广对象*/
    viewPromotionTargets(row) {
      this.currentPromotionData = row;
      this.targetsDialogVisible = true;
      this.loadPromotionTargets(row.id);
    },

    /*加载推广对象数据*/
    loadPromotionTargets(promotionId) {
      this.promotionTargetsLoading = true;
      this.promotionTargets = [];
      
      PromotionApi.getPromotionTargets({
        tid: promotionId
      }).then(res => {
        this.promotionTargetsLoading = false;
        if (res.code === 1 && res.data) {
          this.promotionTargets = res.data.phone || [];
          this.company_name = res.data.company_name || '';
        } else {
          this.$message.warning('暂无推广对象数据');
        }
      }).catch(() => {
        this.promotionTargetsLoading = false;
        this.$message.error('加载推广对象数据失败');
      });
    },

    /*关闭推广对象对话框*/
    handleTargetsClose() {
      this.targetsDialogVisible = false;
      this.currentPromotionData = null;
      this.promotionTargets = [];
      this.company_name = '';
    },

    /*拨打电话*/
    makePhoneCall(phone) {
      if (!phone) {
        this.$message.warning('手机号为空');
        return;
      }
      
      this.$message.info(`拨打: ${phone}`);
      
      try {
        window.location.href = `tel:${phone}`;
      } catch (error) {
        console.log('拨号功能在当前环境不可用');
      }
    },

    /*复制手机号*/
    copyPhoneNumber(phone) {
      if (!phone) {
        this.$message.warning('手机号为空');
        return;
      }
      
      navigator.clipboard.writeText(phone).then(() => {
        this.$message.success('手机号已复制到剪贴板');
      }).catch(() => {
        const textArea = document.createElement('textarea');
        textArea.value = phone;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success('手机号已复制到剪贴板');
        } catch (err) {
          this.$message.error('复制失败');
        }
        document.body.removeChild(textArea);
      });
    },

    /*获取状态文本*/
    getStatusText(status) {
      const statusTextMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束',
      };
      return statusTextMap[status] || '';
    },

    /*获取状态标签类型*/
    getStatusTagType(status) {
      const typeMap = {
        0: 'info',
        1: 'success',
        2: 'warning'
      };
      return typeMap[status] || 'info';
    }
  }
};
</script>

<style scoped>
.promotion-records {
  padding: 20px;
}

.user-info-card {
  margin-bottom: 20px;
}

.user-info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.user-info-item label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.user-avatar {
  border-radius: 50%;
}

.stats-card {
  margin-bottom: 20px;
}

.stat-item {
  text-align: center;
  padding: 20px 0;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

.promotion-title {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.common-seach-wrap {
  margin-bottom: 20px;
}

.product-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.echarts-container {
  margin-bottom: 20px;
}

.chart-card {
  padding: 10px;
}

.promotion-info-card {
  margin-bottom: 20px;
}

.info-item {
  margin-bottom: 10px;
}

.info-item label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.targets-list-card {
  margin-top: 20px;
}

.loading-container,
.empty-container {
  padding: 40px 0;
  text-align: center;
}

.targets-stats {
  margin-bottom: 16px;
}

.phone-list {
  max-height: 400px;
  overflow-y: auto;
}

.phone-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s;
}

.phone-item:hover {
  background-color: #f5f7fa;
}

.phone-item:last-child {
  border-bottom: none;
}

.phone-info {
  display: flex;
  align-items: center;
}

.phone-number {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.phone-actions {
  display: flex;
  gap: 8px;
}

@media (max-width: 768px) {
  .phone-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .phone-actions {
    align-self: flex-end;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/report/promotion_log.vue